import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import RendererRichText from '@components/renderers/render-rich-text'
import Typography from '@material-ui/core/Typography'
import FeaturedCta from '@components/featured-cta-wrapper/featured-cta'
import Grid from '@material-ui/core/Grid'
import { useStyles } from './custom-hero.styles'

const QuickLinks = forwardRef((props, ref) => {
  const {
    heading, summary, linksCollection, offset,
  } = props
  if (!heading) {
    return null
  }
  const styles = useStyles({ offset })

  return (
    <Box ref={ref} className={styles.quickLinksRoot}>
      <Box className={styles.quickLinksWrapper}>
        <Container>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={7}>
              <Typography variant="h2" gutterBottom>
                {heading}
              </Typography>
              {summary && (
                <div className={styles.quickLinksSummary}>
                  <RendererRichText {...summary} />
                </div>
              )}
            </Grid>
            <Grid item xs={12} sm={5}>
              <div className={styles.quickLinksList}>
                {linksCollection.items.map((link) => (
                  <FeaturedCta
                    headline={link.ctaText}
                    slug={link.ctaUrl}
                    image={link.ctaIcon}
                    key={link.ctaText}
                  />
                ))}
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  )
})

QuickLinks.propTypes = {
  heading: PropTypes.string,
  summary: PropTypes.object,
  linksCollection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        ctaText: PropTypes.string,
        ctaUrl: PropTypes.string,
        ctaIcon: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    ),
  }),
  offset: PropTypes.number,
}

export default QuickLinks
